/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import { Box, IconButton } from "@mui/material";
import axios from "axios";
import moment from "moment";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import io from "socket.io-client";
import Loading from "../Loading";
import HrDebug from "./HrDebug";

// ==================================================== //
// 디비그 모드
// ==================================================== //
const debug = 0;

// ==================================================== //
// 스타일 정의
// ==================================================== //

const Container = styled.div`
  .rootContainer {
    background: url(/img/hr_bg.jpg?v=2019-10-08) no-repeat;
    height: 100vh;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
  .bg {
    border: 2px solid green;
  }

  .br {
    border: 2px solid red;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .yellow {
    color: #fffb3b;
  }

  .bg-red {
    background: #df0011;
  }

  .bg-yellow {
    background: #cd9d24;
  }
  .bg-green {
    background: #007a5b;
  }

  .bg-blue {
    background: #006ab6;
  }

  .bg-gray {
    background: #666666;
  }

  .hrContainer {
    flex: 1;
  }

  .zoneContainer {
    display: flex;
  }

  .zoneContainer .item {
    height: 60px;
    width: 20%;
    color: white;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Orbitron", sans-serif;
  }

  .bandContainer {
    margin-left: 15px;
  }

  .bandContent {
    float: left;
    width: 430px;
    height: 210px;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
    overflow: hidden;
  }

  /* large */
  .bandContainer.large .bandContent {
    width: 350px;
  }

  .bandContent .faceData {
    position: absolute;
    z-index: 200;
    padding-top: 10px;
    padding-left: 10px;
  }

  /* large */
  .bandContainer.large .faceData {
    padding-top: 5px;
    padding-left: 5px;
  }

  .bandContent .nameData {
    position: absolute;
    z-index: 100;
    color: white;
    font-size: 50px;
    text-align: right;
    width: 420px;
  }

  /* large */
  .bandContainer.large .nameData {
    font-size: 42px;
    width: 340px;
  }

  .bandContent .nameBG {
    position: absolute;
    width: 430px;
    height: 60px;
    background-color: #000000;
    opacity: 0.1;
  }

  /* large */
  .bandContainer.large .nameBG {
    width: 350px;
  }

  .bandContent .heartData {
    position: absolute;
    text-align: right;
    width: 425px;
    margin-top: 60px;
    color: white;
    font-size: 36px;
    font-family: "Orbitron";
  }

  /* large */
  .bandContainer.large .heartData {
    width: 350px;
  }

  .bandContent .heartMax {
    position: absolute;
    width: 425px;
    text-align: right;
    font-family: "Orbitron";
    color: white;
    font-size: 55px;
    margin-top: 95px;
  }

  /* large */
  .bandContainer.large .heartMax {
    width: 350px;
    font-size: 46px;
  }

  .minute {
    font-family: "Orbitron";
    position: absolute;
    color: white;
    margin-top: 105px;
    margin-left: 10px;
    font-size: 23px;
  }

  .bandContainer.large .minute {
    margin-top: 147px;
    font-size: 21px;
  }

  .kcal {
    font-family: "Orbitron";
    position: absolute;
    color: white;
    margin-top: 128px;
    margin-left: 10px;
    font-size: 23px;
  }

  .bandContainer.large .kcal {
    margin-top: 170px;
    font-size: 21px;
  }

  .bandContent .faceFrame {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }

  .bandContent .faceFrame img {
    width: 90px;
    height: 90px;
  }

  .bandContent .rate .R {
    font-family: "Orbitron";
    float: right;
    color: white;
    font-size: 58px;
    padding-right: 10px;
  }

  .logoWrap {
    display: flex;
    align-items: center;
  }
  .logoWrap .fullscreen {
    margin-left: 30px;
    padding: 5px 10px;
  }

  /* large */
  .win_animation {
    width: 430px;
    height: 200px;
  }
  .bandContainer.large .win_animation {
    width: 350px;
  }

  .bandContainer.large .run_man {
    display: none;
  }

  .bandContainer.large .progress_bar {
    display: none;
  }
`;

let load_bands = localStorage.getItem("bands");
load_bands = JSON.parse(load_bands);
let bands = load_bands !== null ? load_bands : [];
let socket;

function HrNew() {
  // production
  const config = {
    api: "https://api.docircuit.org:3001",
  };

  const [loaded, setLoaded] = useState(false);
  const [devices, setDevices] = useState([]);
  const { ccid, kiosk_id } = queryString.parse(window.location.search);
  const [cid, setCid] = useState(""); // 두써킷 센터코드 (빈값은 심박전용 센터)
  const [toggle, setToggle] = useState(true); // 시스템 on/off

  // ==================================================== //
  // 1. Helper Functions (Logic)
  // ==================================================== //

  // 칼로리 계산
  function timer_sum_cal() {
    let zone_point = 0;

    if (!toggle) {
      if (debug) {
        console.log("시스템 OFF - 칼로리 적립 안함");
      }
      return;
    }

    for (let i = 0; i < bands.length; i++) {
      var HR = bands[i].heart_beat;
      var W = bands[i].weight;
      var A = bands[i].age;
      var T = 1 / 60 / 60;
      // 30초 이상 신호 없으면 칼로리 계산 중단
      if (bands[i].frequency > 30) continue;

      var cal =
        ((-55.0969 + 0.6309 * HR + 0.1988 * W + 0.2017 * A) / 4.184) * 30 * T;

      if (bands[i].kcal >= 1000) {
      } else {
        bands[i].kcal = bands[i].kcal + cal;
      }

      // 구간별 머문시간(초)
      bands[i].sec++;
      if (bands[i].heart_zone === 1) bands[i].zone1++;
      if (bands[i].heart_zone === 2) bands[i].zone2++;
      if (bands[i].heart_zone === 3) bands[i].zone3++;
      if (bands[i].heart_zone === 4) bands[i].zone4++;
      if (bands[i].heart_zone === 5) bands[i].zone5++;

      // 구간 포인트 합산
      zone_point =
        parseInt(bands[i].zone1 * 0) +
        parseInt(bands[i].zone2 / 18) +
        parseInt(bands[i].zone3 / 15) +
        parseInt(bands[i].zone4 / 12) +
        parseInt(bands[i].zone5 / 10);
      if (zone_point > 100) zone_point = 100;
      bands[i].zone_point = zone_point;
    }
  }

  // 밴드 정리 (오래된 데이터 삭제)
  function clear_bands() {
    const clear_time = 60 * 5; // 5min
    bands = bands.filter((item) => item.frequency < clear_time);
  }

  // 로컬 스토리지 저장
  const store_state = () => {
    localStorage.setItem("bands", JSON.stringify(bands));
  };

  // 밴드 UI 그리기 (정렬 및 업데이트)
  function draw_bands() {
    var time = moment(new Date()); //todays date

    // 칼로리 역순 + 밴드번호 역순 정렬
    bands.sort((a, b) => {
      var k1 = a.kcal;
      var k2 = b.kcal;
      var d1 = a.device_id;
      var d2 = b.device_id;
      if (k2 - k1 === 0) {
        return d2 - d1;
      } else {
        return k2 - k1;
      }
    });

    // Frequency 계산
    let frequency_obj, frequency;
    for (let i = 0; i < bands.length; i++) {
      frequency_obj = moment.duration(time.diff(bands[i].time));
      frequency = frequency_obj.asSeconds();
      bands[i].frequency = frequency; // 마지막 수신 후 지난시간(초)
    }
    setDevices((state) => [...bands]); // 화면 업데이트
  }

  // 심박 데이터 업데이트
  function update_heart(idx, heart_beat, time) {
    // 최대심박 계산
    var age = bands[idx].age;
    var heart_max = 220 - age;
    var heart_max_rate = parseInt((100 * heart_beat) / heart_max);
    var heart_zone = 1;
    var bg_color = "bg-gray";

    // 심박구간 계산
    if (heart_max_rate >= 60 && heart_max_rate < 70) {
      bg_color = "bg-blue";
      heart_zone = 2;
    } else if (heart_max_rate >= 70 && heart_max_rate < 80) {
      bg_color = "bg-green";
      heart_zone = 3;
    } else if (heart_max_rate >= 80 && heart_max_rate < 90) {
      bg_color = "bg-yellow";
      heart_zone = 4;
    } else if (heart_max_rate >= 90) {
      bg_color = "bg-red";
      heart_zone = 5;
    }

    bands[idx].heart_beat = heart_beat;
    bands[idx].time = time;
    bands[idx].heart_max = heart_max;
    bands[idx].heart_max_rate = heart_max_rate;
    bands[idx].heart_zone = heart_zone;
    bands[idx].bg_color = bg_color;

    if (bands[idx].heart_beat_max < heart_beat) {
      bands[idx].heart_beat_max = heart_beat;
    }
  }

  // ==================================================== //
  // 2. API & Socket Handlers
  // ==================================================== //

  // 회원 정보 동기화
  const post_sync = async () => {
    let result = await axios.post(
      config.api + "/hr/band_active",
      { ccid: ccid },
      { timeout: 5000 },
    );
    let active_band = result.data.rows;

    let idx;
    for (let i = 0; i < bands.length; i++) {
      if (bands[i].mcd === "") {
        idx = active_band.findIndex(
          (el) => el.device_id === bands[i].device_id,
        );
        if (idx > -1) {
          bands[i].mb_name = active_band[idx].mb_name;
          bands[i].mcd = active_band[idx].mcd;
          bands[i].age = active_band[idx].age;
          bands[i].weight = active_band[idx].weight;
          bands[i].sex = active_band[idx].sex;
          bands[i].avatar = active_band[idx].avatar;
          bands[i].kpoint = active_band[idx].kpoint;
          bands[i].kcal = 0;
          bands[i].kcal_shot = 0;
          bands[i].zone_point = 0;
          bands[i].sec = 0;
          bands[i].zone1 = 0;
          bands[i].zone2 = 0;
          bands[i].zone3 = 0;
          bands[i].zone4 = 0;
          bands[i].zone5 = 0;
          bands[i].heart_beat_max = 0;
          bands[i].heart_max_rate = 0;
          bands[i].heart_zone = 1;
          bands[i].bg_color = "bg-gray";
          bands[i].heart_point = 0;
          bands[i].run = 1;
        }
      }
    }
  };

  // 신규 밴드 서버 등록
  const post_band_new = async (data) => {
    await axios.post(config.api + "/hr/band_add", data);
  };

  // 심박 포인트 적립 (1일 1회 100포인트)
  const onSavePoint = async () => {
    const filter = bands.filter(
      (el) => el.mcd !== "" && el.zone_point >= 100 && el.heart_point === 0,
    );

    if (filter.length > 0) {
      console.log("포인트 지급 대상:", filter.length, "명");
    }

    for (let i = 0; i < filter.length; i++) {
      // 포인트 지급
      await axios.post(
        config.api + "/hr/save_heart_point",
        {
          cid: cid,
          hmcd: filter[i].mcd,
          point: 100,
          heart_max_rate: filter[i].heart_max_rate || 0,
        },
        { timeout: 5000 },
      );

      filter[i].heart_point = 100; // 화면 업데이트

      // 푸시 알림
      await axios.post(
        config.api + "/push/to_hmcd",
        {
          cid: cid,
          hmcd: filter[i].mcd,
          title: "심박",
          message: "심박포인트 100포인트가 적립되었습니다.",
        },
        { timeout: 5000 },
      );
    }
  };

  // 소켓 데이터 수신 처리
  const handleBand = async (data) => {
    let { device_id, heart_beat, time } = data;
    device_id = device_id + "";

    let idx = bands.findIndex((e) => e.device_id === device_id);
    let target = bands.filter((e) => e.device_id === device_id);

    if (idx === -1 && target.length === 0) {
      console.log("New Band Detected:", device_id);

      // 밴드 매핑 정보 조회
      let result = await axios.post(config.api + "/hr/get_center_band", {
        ccid: ccid,
      });
      let idx1 = result.data.rows.findIndex((el) => el.serial === device_id);
      let band_no = "";
      if (idx1 > -1) {
        band_no = result.data.rows[idx1].band_no;
      }

      const newData = {
        ccid: ccid,
        sec: 0,
        zone1: 0,
        zone2: 0,
        zone3: 0,
        zone4: 0,
        zone5: 0,
        device_id: device_id,
        heart_beat: heart_beat,
        heart_beat_max: 0,
        regtime: time,
        time: time,
        mb_name: "",
        kcal: 0,
        age: 40,
        weight: 60,
        heart_max: 0,
        heart_max_rate: 0,
        avatar: "/avatar_img/no_mb.png",
        heart_zone: 1,
        bg_color: "bg-gray",
        run: 1,
        frequency: 0,
        zone_point: 0,
        sex: "남",
        mcd: "",
        heart_point: 0,
        band_no: band_no,
        kcal_shot: 0,
        kpoint: 0,
      };
      bands.push(newData);
      post_band_new(newData);
    } else {
      update_heart(idx, heart_beat, time);
    }
  };

  // ==================================================== //
  // 3. Effects (Intervals & Initial Setup)
  // ==================================================== //

  // 키오스크 로그인 체크
  useEffect(() => {
    axios
      .post(config.api + "/hr/kiosk_login", { ccid: ccid, kiosk_id: kiosk_id })
      .then((res) => {
        if (res.data.success === 1) {
          setLoaded(true);
          if (res.data.cid !== "") {
            setCid(res.data.cid);
          }
        } else {
          window.location.href = "/";
        }
      })
      .catch((e) => {
        alert(e);
      });
  }, []);

  // Socket 연결
  useEffect(() => {
    socket = io.connect("http://localhost:9125", {
      cors: {
        origin: "*",
        withCredentials: true,
      },
    });
    socket.on("connect", () => console.log("socket - connected!"));
    socket.on("disconnect", () => console.log("socket - diconnected!"));
    socket.on("data", (data) => handleBand(data));

    return () => {
      socket.disconnect();
    };
  }, []);

  // 타이머 모음
  useEffect(() => {
    const calcTimer = setInterval(timer_sum_cal, 1000); // 1초: 칼로리 계산
    const drawTimer = setInterval(draw_bands, 1000 / 3); // 0.33초: 화면 갱신
    const clearTimer = setInterval(clear_bands, 1000 * 30); // 30초: 밴드 정리
    const storeTimer = setInterval(store_state, 3000); // 3초: 로컬저장
    const syncTimer = setInterval(post_sync, 6000); // 6초: 회원동기화

    return () => {
      clearInterval(calcTimer);
      clearInterval(drawTimer);
      clearInterval(clearTimer);
      clearInterval(storeTimer);
      clearInterval(syncTimer);
    };
  }, [toggle]); // toggle 상태에 의존적인 로직(timer_sum_cal)이 있으므로 포함

  // 심박 포인트 지급 타이머
  useEffect(() => {
    if (!cid) return;
    const pointTimer = setInterval(onSavePoint, 1000 * 3);
    return () => clearInterval(pointTimer);
  }, [cid]);

  // 칼로리 스냅샷 전송 타이머 (1분)
  useEffect(() => {
    if (!cid) return;
    const snapshot = async () => {
      console.log("snapshot");
      let kcal = 0;
      let kcal_shot = 0;
      let amount = 0;
      let members = [];
      let mcd = "";
      let frequency = 0;

      // 데이터 수집
      for (let i = 0; i < bands.length; i++) {
        kcal = parseInt(bands[i].kcal);
        kcal_shot = parseInt(bands[i].kcal_shot);
        frequency = parseInt(bands[i].frequency);
        mcd = bands[i].mcd;

        if (kcal > kcal_shot) {
          amount = kcal - kcal_shot;
          if (mcd !== "") {
            members.push({
              device_id: bands[i].device_id,
              mcd: mcd,
              add: amount,
              kcal: kcal,
              kcal_shot: kcal_shot,
            });
          } else {
            bands[i].kcal_shot = kcal;
          }
        }
      }

      console.log(members);

      // 서버 전송
      if (members.length > 0) {
        console.log("칼로리 전송 시도:", members.length + "명");
        try {
          const res = await axios.post(
            config.api + "/hr/kcal_add",
            { cid: cid, members: members },
            { timeout: 5000 },
          );
          if (res.data.success === 1) {
            console.log("전송 성공");
            members.forEach((member) => {
              const band = bands.find((b) => b.device_id === member.device_id);
              if (band) {
                band.kcal_shot = member.kcal;
              }
            });
          }
        } catch (e) {
          console.log("전송 에러:", e);
        }
      }
    };

    const snapshotTimer = setInterval(snapshot, 1000 * 60 * 1);
    return () => clearInterval(snapshotTimer);
  }, [cid]);

  const toggle_full_screen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(
          `Error attempting to enable full-screen mode: ${err.message} (${err.name})`,
        );
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <>
      {!loaded ? (
        <Loading></Loading>
      ) : (
        <Container>
          <HelmetProvider>
            <Helmet>
              <link
                rel="stylesheet"
                type="text/css"
                href="https://fonts.googleapis.com/css?family=Audiowide|Michroma|Orbitron|Russo+One"
              />
            </Helmet>
          </HelmetProvider>
          {/* <button onClick={onSavePointTest}>포인트주기</button> */}

          {/* 디버그 모드 */}
          {debug === 1 && <HrDebug bands={devices} cid={cid} />}

          <div className="rootContainer">
            <div className="hrContainer">
              <div className="logoWrap">
                <div style={{ marginLeft: 10 }}>
                  <img src="/img/logo-landscape.png?v=99" width="150" />
                </div>
                <div>
                  <IconButton
                    css={css`
                      margin-left: 30px;
                      background: white;
                      border: 2px solid black;
                    `}
                    onClick={toggle_full_screen}
                  >
                    <ZoomOutMapIcon />
                  </IconButton>
                </div>
              </div>
              <div
                css={css`
                  height: 10px;
                `}
              ></div>

              {/* 밴드 수량별 디자인 다르게 적용하기 :*/}
              <div
                className={
                  devices.length > 16 ? "bandContainer large" : "bandContainer"
                }
              >
                {/* <div>{devices.length}</div> */}
                {devices.map((item, index) => {
                  if (index > 19) return; // 최대 밴드 수

                  let bg_color = item.bg_color;
                  let min = (item.sec / 60).toFixed(0);
                  let width = (430 / 100) * item.zone_point + "px"; // 진행 바
                  let left = (380 / 100) * item.zone_point + "px"; // 사람위치
                  if (cid === "") left = 0;
                  let kpoint = 0;
                  if (item.mcd !== "") {
                    kpoint = item.kpoint + parseInt(item.kcal); // 칼로리 포인트
                  }

                  return (
                    <div className={"bandContent " + bg_color} key={index}>
                      {!toggle && (
                        <Box
                          css={css`
                            z-index: 9999;
                            position: absolute;
                            background: white;
                          `}
                        >
                          지금은 쉬는시간입니다.
                        </Box>
                      )}

                      <div className="faceData">
                        <div className="faceFrame">
                          <img src={item.avatar} />
                        </div>
                      </div>
                      <div className="nameData">
                        {item.mb_name}{" "}
                        {item.mb_name === "" ? item.device_id : null} -{" "}
                        {item.band_no}
                      </div>
                      <div className="nameBG"></div>
                      <div className="heartData">
                        <span>
                          <img
                            className="icon_heart"
                            src="/img/heart_img.png"
                            width="20"
                          />
                        </span>
                        <span
                          css={css`
                            margin-left: 5px;
                            padding-right: 10px;
                          `}
                        >
                          {item.heart_beat}
                        </span>

                        {cid !== "" && ( // 직영점만 포인트 나옴
                          <>
                            <span>
                              <img
                                className="icon_point"
                                src="/img/icon_p.png"
                                width="23"
                              />
                            </span>
                            <span
                              css={css`
                                margin-left: 5px;
                                padding-right: 10px;
                              `}
                            >
                              {item.zone_point}
                            </span>
                          </>
                        )}
                      </div>

                      <div className="heartMax">
                        <span>{item.heart_max_rate}</span>
                        <span
                          css={css`
                            padding-right: 10px;
                          `}
                        >
                          %
                        </span>
                      </div>

                      <div className="kcal">
                        <span>
                          <img src="/img/history.png" width="16"></img>
                        </span>
                        <span
                          css={css`
                            margin-left: 4px;
                          `}
                        >
                          {min}
                        </span>
                        <span
                          css={css`
                            margin-left: 3px;
                          `}
                        >
                          min
                        </span>
                      </div>

                      <div className="minute">
                        <span>
                          <img src="/img/cal.png" width="16"></img>
                        </span>
                        <span
                          css={css`
                            margin-left: 5px;
                          `}
                        >
                          {parseInt(item.kcal)}
                        </span>
                        <span
                          css={css`
                            margin-left: 3px;
                          `}
                        >
                          kcal
                        </span>
                      </div>

                      {/* 사람 */}
                      <Box
                        sx={{
                          position: "absolute",
                          marginTop: 20,
                          marginLeft: left,
                        }}
                      >
                        {cid !== "" && item.zone_point < 99 && (
                          <Box className="run_man">
                            <img
                              src={`/run/run${
                                item.heart_zone === 1 ? 2 : item.heart_zone
                              }.gif`}
                              width="50"
                            ></img>
                          </Box>
                        )}
                        {cid === "" && (
                          <Box className="run_man">
                            <img
                              src={`/run/run${
                                item.heart_zone === 1 ? 2 : item.heart_zone
                              }.gif`}
                              width="50"
                            ></img>
                          </Box>
                        )}
                      </Box>

                      {/* 도착한 사람 */}
                      {cid !== "" && item.zone_point > 99 && (
                        <Box
                          className="run_man"
                          sx={{
                            position: "absolute",
                            marginTop: 19.5,
                            marginLeft: left,
                          }}
                        >
                          <img src="/run/win.gif" width="48"></img>
                        </Box>
                      )}

                      {/* 진행바 */}
                      {cid !== "" && (
                        <Box
                          className="progress_bar"
                          sx={{
                            position: "absolute",
                            backgroundColor: "gray",
                            width: width,
                            height: 3,
                            marginTop: 25.8,
                          }}
                        ></Box>
                      )}

                      {/* 축하아이콘 */}
                      {cid !== "" && item.zone_point > 99 && (
                        <Box sx={{ position: "absolute" }}>
                          <img
                            className="win_animation"
                            src="/run/bomb.gif"
                          ></img>
                        </Box>
                      )}
                    </div>
                  );
                })}
                <Box sx={{ clear: "both" }}></Box>
              </div>
            </div>
            <Box className="zoneContainer">
              <div className="item bg-gray"> 50% - 60%</div>
              <div className="item bg-blue"> 60% - 70%</div>
              <div className="item bg-green">70% - 80%</div>
              <div className="item bg-yellow">80% - 90%</div>
              <div className="item bg-red">90% - 100%</div>
            </Box>
          </div>
        </Container>
      )}
    </>
  );
}

export default HrNew;
